import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import LogoutStore from '../stores/logoutStore';

export const useLogoutStore = () => useContext<{
  logoutStore: LogoutStore
}>(StoreContext);
